<script>
import { isStatsActive } from '~/lib/growthbook/statsState'

export default {
  // name: 'ProjectEvent',
  methods: {
    gbLogEvent (name, properties) {
      if (this.$gb && isStatsActive()) {
        this.$gb.logEvent(name, { ...properties, occurred_at: new Date().toISOString() })
      }
    },
    projectEventProductView (product, userId) {
      if (this.$gtag) {
        const item = {
          id: product.id,
          ecomm_prodid: product.id,
          google_business_vertical: 'retail'
        }

        if (product.categories && product.categories.length) {
          item.category = product.categories[0].description.name
        }

        this.$gtag('event', 'view_item', {
          send_to: 'AW-666487120',
          items: [item],
          value: product.summary.price,
          user_id: userId
        })
      }
      if (this.$gb) {
        this.gbLogEvent('view_item', {
          value: product && product.summary ? product.summary.price : 0,
          product_id: product ? product.id : null
        })
      }
    },

    projectEventProductAddToCart (product, prices, quantity) {
      if (this.$gtag) {
        this.$gtag('event', 'add_to_cart', {
          send_to: 'AW-666487120',
          items: [
            {
              id: product.id,
              ecomm_prodid: product.id,
              google_business_vertical: 'retail'
            }
          ],
          value: prices.totalPrice
        })
      }
      if (this.$gb) {
        this.gbLogEvent('add_to_cart', {
          value: prices ? prices.totalPrice : 0,
          quantity: quantity || 1,
          product_id: product ? product.id : null
        })
      }
    },

    projectEventRemoveProductFromCart (product) {
      if (this.$gb) {
        this.gbLogEvent('remove_from_cart', {
          value: product && product.summary ? product.summary.price : 0,
          product_id: product ? product.id : null
        })
      }
    },

    projectEventCheckoutView (orders) {
      if (this.$gb && Array.isArray(orders) && orders.length) {
        let value = 0
        orders.forEach((order) => {
          const total = order.totals && order.totals.find(x => x.type === 'finalTotal')
          if (total) { value += total.price }
        })
        this.gbLogEvent('begin_checkout', {
          value,
          currency: orders[0].currency
        })
      }
    },

    projectEventCheckoutOptionPayment (option, orders) {
      if (this.$gb && Array.isArray(orders) && orders.length) {
        let value = 0
        orders.forEach((order) => {
          const total = order.totals && order.totals.find(x => x.type === 'finalTotal')
          if (total) { value += total.price }
        })
        this.gbLogEvent('add_payment_info', {
          value,
          currency: orders[0].currency,
          payment_type: option
        })
      }
    },

    projectEventCheckoutOptionShipping (option, orders) {
      if (this.$gb && Array.isArray(orders) && orders.length) {
        let value = 0
        orders.forEach((order) => {
          const total = order.totals && order.totals.find(x => x.type === 'finalTotal')
          if (total) { value += total.price }
        })
        this.gbLogEvent('add_shipping_info', {
          value,
          currency: orders[0].currency,
          shipping_tier: option
        })
      }
    },

    projectEventPurchaseCheckout (orders) {
      if (this.$gtag) {
        orders.forEach((order) => {
          if (order.totals && order.totals.length > 0) {
            const find = order.totals.find(x => x.type === 'finalTotal')
            if (find) {
              this.$gtag('event', 'conversion', {
                send_to: 'AW-666487120/lIQ3CPmv5tMBENCS570C',
                value: find.price,
                currency: order.currency,
                transaction_id: order.orderId
              })

              const items = []

              order.products.forEach((product) => {
                items.push({
                  id: product.offerProductId,
                  ecomm_prodid: product.offerProductId,
                  google_business_vertical: 'retail'
                })
              })

              this.$gtag('event', 'purchase', {
                send_to: 'AW-666487120',
                items,
                value: find.price
              })
            }
          }
        })
      }

      if (this.$gb) {
        orders.forEach((order) => {
          const find = order.totals && order.totals.find(x => x.type === 'finalTotal')
          if (find) {
            this.gbLogEvent('purchase', {
              value: find.price,
              currency: order.currency,
              transaction_id: order.orderId,
              items: (order.products || []).map(p => ({
                id: p.offerProductId,
                name: p.description && p.description.name,
                quantity: p.quantity,
                price: p.summary && p.summary.price
              }))
            })
          }
        })
      }
    },

    projectEventPurchaseSuccessPage (orders) {

    }

  }
}
</script>
